import React from "react";
import {
  TouchableOpacity,
  StatusBar,
  StyleSheet,
  View,
  Modal,
} from "react-native";
// import Orientation from "react-native-orientation-locker";
import CloseIcon from "../../assets/svg/CloseIcon";
import { GetVideoTimeContextProvider } from "../../utils/useGetVideoTime";
import VideoContainer from "./VideoContainer";

const VideoModal = (props) => {
  const {
    show,
    setShow,
    video_link = "",
    onEnd,
    hideCloseIcon,
    pausedEventTrack,
    resumedEventTrack,
  } = props;

  return (
    <Modal
      visible={show}
      onRequestClose={() => {
        setShow(!show);
        // Orientation.lockToPortrait();
        StatusBar.setHidden(false);
        StatusBar.setBarStyle("dark-content");
      }}
    >
      <View style={styles.safeAreaViewStyles}>
        {!hideCloseIcon && (
          <TouchableOpacity
            onPress={() => {
              setShow(!show);
              StatusBar.setHidden(false);
              StatusBar.setBarStyle("dark-content");
              // Orientation.lockToPortrait();
            }}
            style={styles.closeButton}
          >
            <CloseIcon fill="#fff" />
          </TouchableOpacity>
        )}
        <GetVideoTimeContextProvider>
          <VideoContainer
            {...{ video_link, onEnd, pausedEventTrack, resumedEventTrack }}
            handleCta={() => {
              setShow(!show);
              StatusBar.setHidden(false);
              StatusBar.setBarStyle("dark-content");
              // Orientation.lockToPortrait();
            }}
          />
        </GetVideoTimeContextProvider>
      </View>
    </Modal>
  );
};

export default VideoModal;

const styles = StyleSheet.create({
  safeAreaViewStyles: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: "#000000",
    justifyContent: "center",
  },
  closeButton: {
    position: "absolute",
    top: StatusBar.currentHeight + 20,
    right: 23,
    zIndex: 5,
  },
});
